<template>
  <v-flex sm10 offset-sm1>
    <v-card class="eventWizardScreen">
      <form-wizard
        @on-complete="onCompletingTheWizard"
        shape="circle"
        :start-index="0"
        color="#20a0ff"
        error-color="#ff4949"
      >
        <h2 slot="title"></h2>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <tab-content title="Event details" icon="ti-list" :before-change="saveEvent">
          <eventWizard_EventDetails
            :newEventId="newEventId"
            @returnedValueForValidationForm="returnedValueForValidationForm"
            @eventFormIsChanged="eventFormIsChanged"
          ></eventWizard_EventDetails>
        </tab-content>
        <tab-content title="Event Agenda" icon="ti-calendar" :before-change="beforeTabSwitch">
          <eventWizard_EventAgenda :eventForm="eventForm" :newEventId="newEventId"></eventWizard_EventAgenda>
        </tab-content>
        <tab-content title="Event Communication" icon="ti-comments">
          <eventWizard_EventCommunication :eventForm="eventForm" :newEventId="newEventId"></eventWizard_EventCommunication>
        </tab-content>
        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button
              v-if="props.activeTabIndex > 0"
              @click.native="props.prevTab()"
              :style="props.fillButtonStyle"
            >Previous</wizard-button>
          </div>
          <div class="wizard-footer-right">
            <wizard-button
              v-if="!props.isLastStep"
              @click.native="props.nextTab()"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
            >Next</wizard-button>

            <wizard-button
              v-else
              @click.native="goToEventScreen"
              class="wizard-footer-right finish-button"
              :style="props.fillButtonStyle"
            >{{props.isLastStep ? 'Done' : 'Next'}}</wizard-button>
          </div>
        </template>
      </form-wizard>
    </v-card>
    <v-dialog v-model="errorDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline">{{$translate('LINDA_ERROR')}}</v-card-title>
        <v-card-text v-if="recievedErrorMessage !== ''">{{recievedErrorMessage}}</v-card-text>
        <v-card-text v-else>
          {{$translate('EVENT_ERROR_MSG_1')}}
          <br>
          {{$translate('EVENT_ERROR_MSG_2')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" round @click="errorDialog = false">{{$translate('CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css"; // Mandatory to reach the wizard
import { FormWizard, TabContent } from "vue-form-wizard"; // Mandatory to reach the wizard
import appConfig from "../../config/app_config"; // Mandatory to reach the dss objects and other info
import * as dssRequest from "../api/dssRequest"; // Mandatory to do a request for data
import { objectToArray } from "@/shared/utility.js"; // Mandatory to create array of objects from object of objects
import BaseObject from "@/objects/BaseObject.js"; // Mandatory to create array of objects from objject of objects
import _ from "lodash"; // Mandatory to use the lodash accessibilities
import { ui_helpers } from "../shared/ui_helpers"; // Mandatory to reach the ShowComponents functions and other snippets
import EventWizard_EventDetails from "@/components/EventWizard_EventDetails.vue"; // First element (event details) within the wizard
import EventWizard_EventAgenda from "@/components/EventWizard_EventAgenda.vue"; //  Second element (event agenda) within the wizard
import EventWizard_EventCommunication from "@/components/EventWizard_EventCommunication.vue"; // Last element (event communication) within the wizard

export default {
  name: "EventWizard_Main",
  components: {
    // Importing the components that are used within this component
    FormWizard,
    TabContent,
    EventWizard_EventDetails,
    EventWizard_EventAgenda,
    EventWizard_EventCommunication
  },
  mixins: [ui_helpers],
  computed: {},
  data() {
    return {
      // Variables
      returnedValueForValidation: false,
      recievedErrorMessage      : "",
      selectedThemes            : [],
      newEventId                : null,
      valid                     : true,
      eventFormChanged          : false,

      // Dialogs
      errorDialog: false,

      //Form defintion
      eventForm: {},

      // The properties for the add photo wizard
      properties2: {
        title     : "Background",
        signalName: "load_image",
        deletable : false,
        pictureUrl: "",
        maxWidth  : appConfig.maxSize.home.w,
        maxHeight : appConfig.maxSize.home.h,
        scale     : "w"
      }
    };
  },
  created() {
    window.EventBus.listen(
      "recievedTriggerForErrorDialog",
      this.recievedTriggerForErrorDialog
    );
  },
  beforeDestroy() {
  window.EventBus.removeListener(
      "recievedTriggerForErrorDialog",
      this.recievedTriggerForErrorDialog
    );

  },
  mounted() {},
  methods: {
    recievedTriggerForErrorDialog(errorMessage = null) {
      // the child components can trigger this call to start the errordialog
      this.errorDialog = true;
      if (errorMessage !== null) this.recievedErrorMessage = errorMessage;
      return false;
    },
    eventFormIsChanged(
      eventFormNewValue,
      eventFormOldValue,
      newEventId,
      pictureProperties,
      selectedThemes
    ) {
      //Whenever something changes on the eventForm on the child it will trigger this call to update the event-data
      this.eventForm = eventFormNewValue;
      this.properties2 = pictureProperties;
      this.selectedThemes = selectedThemes;
      this.newEventId = newEventId;
      if (eventFormNewValue !== eventFormOldValue && this.newEventId !== null) {
        this.eventFormChanged = true;
      }
    },
    previousStep(tabIndex) {
      // Control saving the event id if it already exists
      console.log("tabIndex is :", tabIndex, this.eventForm);
    },
    onCompletingTheWizard() {
      // On completing the wizard, an alert will be send
      alert("Yay. Done!");
    },
    returnedValueForValidationForm(returnBool) {
      this.returnedValueForValidation = returnBool;
    },
    saveEvent() {
      // if (!this.eventFormChanged) return true; //  <!** TURNED ON FOR TESTING **!>
      // Upon clicking on 'next' on the event details (first) tab, the data will be validated and the event will be saved
      window.EventBus.fire("validateEventForm");
      if (!this.returnedValueForValidation) {
        this.errorDialog = true;
        return false;
      } else {
        if (this.$store.getters["auth/partnerId"] == -1) {
          // If user is not a partner
          alert("To create an event, you must be a partner");
          return false;
        } else {
          // Check if inputs are wrong but form is validated
          if (
            this.eventForm.CooldownTime < 0 ||
            this.eventForm.leadTime < 0 ||
            this.eventForm.EventBudget < 0 ||
            this.eventForm.MaxEventCapacity < 0
          ) {
            this.errorDialog = true;
            return false;
          }
          // Add/adjust the parameters to the object for saving the event
          const payload = {};
          payload.PartnerId = this.$store.getters["auth/partnerId"];
          payload.Owner = this.$store.getters["auth/userName"];
          payload.EndLocationId = "";
          if (this.eventForm.hasOwnProperty("InfoUrl")) {
          // If info URL is available
            payload.InfoUrl = this.eventForm.InfoUrl;
          } else {
            // if info URL is not available
            payload.InfoUrl = "";
          }
          payload.DiscountCards = {};
          payload.RewardLevels = {};
          payload.Tags = {};
          payload.Accounts = {};
          payload.ParentEventRewards = {};
          payload.Type = "Standard";
          payload.EventRanking = Number(0);
          payload.LocationId = this.eventForm.LocationId;
          payload.Picture = this.properties2.pictureUrl;
          payload.CooldownTime = Number(this.eventForm.CooldownTime) * 60;
          payload.LeadTime = Number(this.eventForm.LeadTime) * 60;
          payload.MaxEventCapacity = Number(this.eventForm.MaxEventCapacity);
          payload.Name = this.eventForm.Name;
          payload.TimeWindowType = this.eventForm.TimeWindowType;
          if (this.newEventId !== null) {
            payload.EventId = Number(this.newEventId);
          }
          if (this.eventForm.hasOwnProperty("EventBudget")) {
            payload.EventBudget = Number(this.eventForm.EventBudget);
          } else {
            payload.EventBudget = 0;
          }
          if (this.selectedThemes.length > 0) {
            // If themes are selected, do the following
            let toStoreParentEvents = {};
            this.selectedThemes.forEach(e => {
              if (e !== undefined) {
                if (e.hasOwnProperty("EventId")) {
                  toStoreParentEvents[e.EventId] = e.EventId;
                } else {
                  toStoreParentEvents[e] = e;
                }
              } else {
                toStoreParentEvents = {};
              }
            });
            payload.ParentEvents = toStoreParentEvents;
          } else {
            // If no themes are selected, do the following
            payload.ParentEvents = {};
          }
          let responseData = Boolean;
          payload.FunctionId = "EventFunctionLibrary::saveEvent";
          dssRequest.doRequest(
            response => {
              console.log(
                "The generic call saveEvent was successful",
                response
              );
              if (!response.hasOwnProperty("data")) {
                console.log("error, in the response is no data available");
              }
              if (response.data.hasOwnProperty("EventId")) {
                // Storing recieved event id
                this.newEventId = response.data.EventId;
              }
              if (this.eventForm.Description.length !== 0) {
                // If translation data is available, save event translations
                this.saveEventTranslationInfo();
              }
              if (this.newEventId !== null) {
                // If eventId is available, retrieve her batchgroups
                window.EventBus.fire("getBatchGroupsForEvent", this.newEventId);
              }
              window.EventBus.fire("getEventsBasedOnUserLevel", null);
              responseData = true;
            },
            error => {
              console.log(
                "The generic call saveEvent was not successful",
                error
              );
              responseData = false;
            },
            "communicateWithDBLibrary",
            appConfig.dss.eventAdminMng,
            payload
          );
          if (responseData) {
            // Continue wizard on response
            return true;
          } else {
            // Fail wizard on error
            return false;
          }
        }
      }
    },
    saveEventTranslationInfo() {
      // Saving event translation info regarding the event ( standard: english)
      const payload = {
        EventId: Number(this.newEventId),
        13: {
          EventTranslationName: this.eventForm.Name,
          Description: this.eventForm.Description,
          ArrivalText: "",
          DepartureText: "",
          ArrivalAudio: "",
          DepartureAudio: ""
        },
        FunctionId: "EventFunctionLibrary::saveEventTranslation"
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call for saveEventTranslation was successful",
            response
          );
        },
        error => {
          console.log(
            "The generic call for saveEventTranslation was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    beforeTabSwitch() {
      // // Before the tab switches from batchgroup screen to message screen
      window.EventBus.fire("resetBatchGroupObject");
      window.EventBus.fire("getMessages");
      return true;
    },
    goToEventScreen() {
      //Moves the web to the event screen
      this.showComponents({
        main: "Events_main",
        side: "EventView_Overview"
      });
    }
  }
};
</script>

<style lang = "scss", scoped>

.eventWizardScreen {
  padding-bottom: 3em;
  margin-bottom : 5em;
  margin-top    : 3em;
  border-radius : 3em !important;
  max-height    : 800px !important;
  max-height    : 800px !important;
  max-width     : 1000px !important;
}
</style>
